import { Package2, Droplets, ListOrdered, CheckCircle2, Timer, PlayCircle, Sparkles, Circle } from "lucide-react";

export const STAGES = ["received", "washing_crushing", "malaxation_extraction", "bottling_ready", "completed"];

export const STAGE_META = {
  received: { color: "#3B82F6", icon: ListOrdered },
  washing_crushing: { color: "#F59E0B", icon: Droplets },
  malaxation_extraction: { color: "#8B5CF6", icon: PlayCircle },
  bottling_ready: { color: "#10B981", icon: Package2 },
  completed: { color: "#059669", icon: CheckCircle2 },
};

export const STAGE_PALETTE = ["#3B82F6", "#F59E0B", "#8B5CF6", "#10B981", "#059669", "#EF4444", "#EC4899", "#0EA5E9", "#F97316", "#6366F1"];
const STAGE_ICONS = [ListOrdered, Droplets, PlayCircle, Package2, CheckCircle2, Timer, Sparkles, Circle];

// Resolve color + icon for any stage id, falling back to a rotating palette for custom steps
export function stageMeta(id, index = 0) {
  if (STAGE_META[id]) return STAGE_META[id];
  return { color: STAGE_PALETTE[index % STAGE_PALETTE.length], icon: STAGE_ICONS[index % STAGE_ICONS.length] };
}

// Translated label for default steps, saved label for custom steps
export function stageLabel(t, stage) {
  const key = `st_${stage.id}`;
  const tr = t(key);
  return tr === key ? stage.label : tr;
}

export const PRINTER_FORMATS = ["A4", "58mm", "80mm", "104mm"];

export const VARIETIES = ["extra_virgin", "organic", "unfiltered", "flavored"];
export const CURRENCIES = ["EUR", "ALL"];
export const BOTTLE_SIZES = ["250ml", "500ml", "750ml", "1L", "3L", "5L"];
export const CURRENCY_SYMBOL = { EUR: "€", ALL: "L" };

export const PLANS = [
  { id: "starter", price: "€19", modules: ["live_queue", "thermal_printing", "analytics"], highlight: false },
  { id: "professional", price: "€49", modules: ["live_queue", "thermal_printing", "analytics"], highlight: true },
  { id: "enterprise", price: "€99", modules: ["live_queue", "thermal_printing", "analytics", "store"], highlight: false },
];

export const MODULE_KEYS = ["live_queue", "thermal_printing", "analytics", "store"];

export const YIELD_RATE = 0.15;

export { Timer, Sparkles };
